export default __webpack_public_path__ + "static/media/la_capelle18.4f40197e.jpg";